import React, {useState} from 'react';
import { Modal } from 'react-bootstrap';
//import validator from 'validator';
import SimpleReactValidator from 'pu-utils/simple-react-validator';

const CustomQuoteRequestModal = (props) => {
  const validator = new SimpleReactValidator({})

  const {
    customQuoteRequest,
    parameters, 
    onChangeParameter,
    onCustomQuoteSend,
    onCustomQuoteCancel,
  } = props;

  const [email, setEmail] = useState(parameters.email || Spree.current_user_email);

  const onShowModal = () => {
    validator.hideMessages();
  }

  const handleSend = () => {
    if (!validator.allValid()) {
      validator.showMessages();
      return;
    }

    //$('#quote_form').attr('action', '/pcb_custom_quote_requests/product').submit();
    onCustomQuoteSend();
  }

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
    onChangeParameter('email', e.target.value);
  }

  const onChangePartNumber = (e) => {
    onChangeParameter('part_number', e.target.value);
  }

  const onChangeRevision = (e) => {
    onChangeParameter('revision', e.target.value);
  }

  return (
    <Modal show={customQuoteRequest} onHide={onCustomQuoteCancel} dialogClassName="quote-modal-dialog" onShow={onShowModal}>
      <Modal.Header closeButton>
        <Modal.Title>Custom Quote</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Your quote has custom specs and will require a custom cuote. Our sales team will
          send you a email with the quote.
        </p>
        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <label htmlFor="custom-quote-email">Part Number</label>
              <input
                id="cq-part-number"
                type="text"
                className="form-control"
                onChange={onChangePartNumber}
                value={parameters.part_number} />
              {validator.message('Part Number', parameters.part_number, 'required|min:3')}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label htmlFor="custom-quote-email">Revision</label>
              <input
                id="cq-revision"
                type="text"
                className="form-control"
                onChange={onChangeRevision}
                value={parameters.revision} />
              {validator.message('Revision', parameters.revision, 'required')}
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="custom-quote-email">Email</label>
              <input
                id="cq-email"
                type="text"
                className="form-control"
                onChange={onChangeEmail}
                value={email} />
              {validator.message('Email', email, 'required|email')}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label htmlFor="custom-quote-email">Gerber File</label>
              <button
                type="button"
                onClick={() => $('#gerber-file').click()}
                className="btn btn-block btn-secondary-clear">
                Browse File
              </button>
              <div>{parameters.filename}</div>
              {validator.message('File', parameters.filename, 'required')}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <input type="button" className="btn btn-default" onClick={onCustomQuoteCancel} value="Cancel" />
        <input type="button" className="btn btn-primary" onClick={handleSend} value="Send me a quote" />
      </Modal.Footer>
    </Modal>
  );
};

export default CustomQuoteRequestModal;
